import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {useAccount} from "../hooks/useAccount.ts";

export const EditFormDrawer = (props: DrawerProps) => {
    const {id: accountId} = useParams();

    if (typeof accountId === 'undefined') {
        throw new Error('accountId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useAccount(accountId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
